import React from 'react';
import '../styles/TermsOfUsePage.css';

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="terms-of-use-layout">
      <main className="terms-of-use-content">
        <h1 className="terms-of-use-title">Termos de Uso</h1>
        <p className="terms-of-use-paragraph">
          <strong>Última atualização:</strong> 17/10/2024
        </p>

        <p className="terms-of-use-paragraph">
          Ao acessar ou usar nossa plataforma SaaS, você concorda em cumprir estes Termos de Uso. Leia atentamente antes
          de utilizar nossos serviços.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">1. Aceitação dos Termos</h2>
        <p className="terms-of-use-paragraph">
          Ao criar uma conta ou utilizar a plataforma, você aceita e concorda em cumprir estes termos e todas as leis e
          regulamentos aplicáveis. Se você não concorda com estes termos, não utilize a plataforma.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">2. Elegibilidade</h2>
        <p className="terms-of-use-paragraph">
          Você deve ter pelo menos 18 anos para utilizar nossos serviços. Ao aceitar estes termos, você declara que tem a
          idade legal para firmar um contrato vinculativo e não está impedido de usar os serviços de acordo com as leis
          aplicáveis.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">3. Uso da Plataforma</h2>
        <div className="terms-of-use-paragraph">
          <ul className="terms-of-use-list">
            <li>
              <strong>Conta de Usuário:</strong> Você é responsável por manter a confidencialidade das informações da sua
              conta e por todas as atividades que ocorram sob sua conta. Notifique-nos imediatamente sobre qualquer uso
              não autorizado.
            </li>
            <li>
              <strong>Conduta do Usuário:</strong> Concorda em não utilizar a plataforma para qualquer finalidade ilegal
              ou não autorizada, incluindo, mas não limitado a, violação de direitos de propriedade intelectual ou envio
              de conteúdo ilícito.
            </li>
            <li>
              <strong>Licença de Uso:</strong> Concedemos a você uma licença limitada, não exclusiva e intransferível
              para acessar e usar a plataforma de acordo com estes termos.
            </li>
          </ul>
        </div>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">4. Propriedade Intelectual</h2>
        <p className="terms-of-use-paragraph">
          Todos os direitos, títulos e interesses relacionados à plataforma, incluindo conteúdos, são de nossa propriedade
          ou de nossos licenciadores e são protegidos por leis de propriedade intelectual. Você não deve reproduzir,
          distribuir ou criar obras derivadas sem nossa permissão expressa.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">5. Taxas e Pagamentos</h2>
        <div className="terms-of-use-paragraph">
          <ul className="terms-of-use-list">
            <li>
              <strong>Assinaturas:</strong> Alguns serviços podem exigir pagamento de taxas de assinatura. Os detalhes
              das taxas e planos serão fornecidos no momento da compra.
            </li>
            <li>
              <strong>Política de Reembolso:</strong> Consulte nossa política de reembolso para informações sobre
              cancelamentos e reembolsos. Taxas pagas não são reembolsáveis, exceto conforme exigido por lei.
            </li>
          </ul>
        </div>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">6. Rescisão</h2>
        <p className="terms-of-use-paragraph">
          Reservamo-nos o direito de suspender ou encerrar seu acesso à plataforma a qualquer momento, sem aviso prévio,
          se você violar estes Termos de Uso ou se envolver em conduta que considerarmos prejudicial.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">7. Isenção de Garantias</h2>
        <p className="terms-of-use-paragraph">
          A plataforma é fornecida "como está" e "conforme disponível". Não garantimos que os serviços serão
          ininterruptos, seguros ou livres de erros. Na máxima extensão permitida por lei, isentamo-nos de todas as
          garantias, expressas ou implícitas.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">8. Limitação de Responsabilidade</h2>
        <p className="terms-of-use-paragraph">
          Em nenhum caso seremos responsáveis por quaisquer danos indiretos, incidentais, especiais, consequenciais ou
          punitivos decorrentes ou relacionados ao uso ou incapacidade de uso da plataforma, mesmo que tenhamos sido
          avisados da possibilidade de tais danos.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">9. Indenização</h2>
        <p className="terms-of-use-paragraph">
          Você concorda em nos indenizar e isentar de quaisquer reivindicações, danos, perdas ou despesas (incluindo
          honorários advocatícios razoáveis) decorrentes de sua violação destes termos ou de atividades relacionadas à
          sua conta.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">10. Alterações nos Termos</h2>
        <p className="terms-of-use-paragraph">
          Podemos modificar estes Termos de Uso a qualquer momento. Notificaremos sobre quaisquer mudanças significativas
          publicando os novos termos nesta página e atualizando a data de "Última atualização". Seu uso contínuo da
          plataforma após tais alterações constitui aceitação dos novos termos.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">11. Lei Aplicável e Jurisdição</h2>
        <p className="terms-of-use-paragraph">
          Estes termos serão regidos e interpretados de acordo com as leis do [Seu País/Estado], sem consideração aos
          seus conflitos de princípios legais. Você concorda que qualquer disputa será resolvida nos tribunais
          competentes dessa jurisdição.
        </p>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">12. Disposições Gerais</h2>
        <div className="terms-of-use-paragraph">
          <ul className="terms-of-use-list">
            <li>
              <strong>Acordo Integral:</strong> Estes termos constituem o acordo integral entre você e nós em relação ao
              uso da plataforma, substituindo quaisquer acordos anteriores.
            </li>
            <li>
              <strong>Renúncia e Divisibilidade:</strong> Nossa falha em aplicar qualquer direito ou disposição destes
              termos não constituirá renúncia de tal direito ou disposição. Se qualquer disposição destes termos for
              considerada inválida, as demais disposições permanecerão em vigor.
            </li>
          </ul>
        </div>

        <hr className="terms-of-use-divider" />

        <h2 className="terms-of-use-title">13. Contato</h2>
        <p className="terms-of-use-paragraph">
          Para perguntas ou preocupações sobre estes Termos de Uso, entre em contato conosco através dos meios
          disponíveis em nossa plataforma.
        </p>
      </main>
    </div>
  );
};

export default TermsOfUsePage;
